import React from 'react';

export const NotAuthorized: React.FunctionComponent = () => {
  return <>Not Authorized</>;
};

export default NotAuthorized;
